import {
  CHART_TYPE,
  REPORT_TYPE,
  SORT_OPTIONS,
  TEMPLATE,
  TEMPLATE_GROUP
} from '../constants/Enum';
import { CRMTemplates } from '../templates/CRMTemplates';
import { ERPTemplates } from '../templates/ERPTemplates';
import { AccountingTemplates } from '../templates/AccountingTemplates';
import { APP_NAME, PAGE_ROUTES } from '../constants/Constant';

export type IReport = {
  title: string;
  description: string;
  templateName: TEMPLATE;
  type?: REPORT_TYPE;
  path?: string;
};
export type ITemplateGroup = { title: string; templates: IReport[] };

export default class TemplateManager {
  static templateGroups: ITemplateGroup[] = [
    {
      title: TEMPLATE_GROUP.ERP_REPORTS,
      templates: [
        {
          title: 'Invoice List',
          description: 'Report description will come here',
          templateName: TEMPLATE.INVOICE_LIST
        },
        {
          title: 'Quotation List',
          description: 'Report description will come here',
          templateName: TEMPLATE.QUOTATION_LIST
        },
        {
          title: 'Bills Report',
          description: 'Report description will come here',
          templateName: TEMPLATE.BILL_LIST
        },
        {
          title: 'Orders List',
          description: 'Report description will come here',
          templateName: TEMPLATE.ORDER_LIST
        },
        {
          title: 'Credit Note List',
          description: 'Report description will come here',
          templateName: TEMPLATE.CREDIT_NOTE_LIST
        },
        {
          title: 'Debit Note List',
          description: 'Report description will come here',
          templateName: TEMPLATE.DEBIT_NOTE_LIST
        },
        {
          title: 'Receipts List',
          description: 'Report description will come here',
          templateName: TEMPLATE.RECEIPT_LIST
        },
        {
          title: 'Payment List',
          description: 'Report description will come here',
          templateName: TEMPLATE.PAYMENT_LIST
        },
        {
          title: 'Badge Serial Ledger',
          description: 'Report description will come here',
          templateName: TEMPLATE.BATCH_SERIAL_LEDGER
        },
        {
          title: 'Stock Movement',
          description: 'Report description will come here',
          templateName: TEMPLATE.STOCK_MOVEMENT
        },
        {
          title: 'Inventory Dashboard',
          description: 'Report description will come here',
          templateName: TEMPLATE.INVENTORY_DASHBOARD
        }
      ]
    },
    {
      title: TEMPLATE_GROUP.ACCOUNTING_REPORTS,
      templates: [
        {
          title: 'Profit & Loss',
          description: 'Report description will come here',
          templateName: TEMPLATE.PROFIT_AND_LOSS,
          path: PAGE_ROUTES.PROFIT_LOSS
        },
        {
          title: 'Balance Sheet',
          description: 'Report description will come here',
          templateName: TEMPLATE.BALANCE_SHEET,
          path: PAGE_ROUTES.BALANCE_SHEET
        },
        {
          title: 'Profit & Loss by month',
          description: 'Report description will come here',
          templateName: TEMPLATE.PROFIT_AND_LOSS_BY_MONTH,
          path: PAGE_ROUTES.PROFIT_LOSS,
          type: REPORT_TYPE.PROFIT_AND_LOSS_BY_MONTH
        },
        {
          title: 'Balance Sheet by month',
          description: 'Report description will come here',
          templateName: TEMPLATE.BALANCE_SHEET_BY_MONTH,
          path: PAGE_ROUTES.BALANCE_SHEET,
          type: REPORT_TYPE.BALANCE_SHEET_BY_MONTH
        },
        {
          title: 'Profit & Loss by quarter',
          description: 'Report description will come here',
          templateName: TEMPLATE.PROFIT_AND_LOSS_BY_QUARTER,
          path: PAGE_ROUTES.PROFIT_LOSS,
          type: REPORT_TYPE.PROFIT_AND_LOSS_BY_QUARTER
        },
        {
          title: 'Balance Sheet by quarter',
          description: 'Report description will come here',
          templateName: TEMPLATE.BALANCE_SHEET_BY_MONTH,
          path: PAGE_ROUTES.BALANCE_SHEET,
          type: REPORT_TYPE.BALANCE_SHEET_BY_QUARTER
        },
        {
          title: 'Profit & Loss by year',
          description: 'Report description will come here',
          templateName: TEMPLATE.PROFIT_AND_LOSS_BY_YEAR,
          path: PAGE_ROUTES.PROFIT_LOSS,
          type: REPORT_TYPE.PROFIT_AND_LOSS_BY_YEAR
        },
        {
          title: 'Balance Sheet by year',
          description: 'Report description will come here',
          templateName: TEMPLATE.BALANCE_SHEET_BY_YEAR,
          path: PAGE_ROUTES.BALANCE_SHEET,
          type: REPORT_TYPE.BALANCE_SHEET_BY_YEAR
        },
        {
          title: 'Profit & Loss Details',
          description: 'Report description will come here',
          templateName: TEMPLATE.PROFIT_AND_LOSS_DETAILS,
          path: PAGE_ROUTES.PNL_DETAIL
        },
        {
          title: 'Balance Sheet Details',
          description: 'Report description will come here',
          templateName: TEMPLATE.BALANCE_SHEET_DETAILS,
          path: PAGE_ROUTES.BS_DETAIL
        },
        {
          title: 'Trial Balance',
          description: 'Report description will come here',
          templateName: TEMPLATE.TRIAL_BALANCE,
          path: PAGE_ROUTES.TRIAL_BALANCE
        },
        {
          title: 'Trial Balance Details',
          description: 'Report description will come here',
          templateName: TEMPLATE.TRIAL_BALANCE_DETAILS,
          path: PAGE_ROUTES.TB_DETAIL
        }
      ]
    },
    {
      title: TEMPLATE_GROUP.CRM_REPORTS,
      templates: [
        {
          title: 'Contact with Deals',
          description: 'Report description will come here',
          templateName: TEMPLATE.CONTACT_WITH_DEALS
        },
        {
          title: 'Won Deals With Contact ',
          description: 'Won Deals With Contact ',
          templateName: TEMPLATE.WON_DEAL_WITH_CONTACT
        },
        {
          title: 'Contact With Activity',
          description: 'Contact With Activity',
          templateName: TEMPLATE.ACTIVITY_REPORT
        },
        {
          title: 'Contact With Ticket',
          description: 'Contact With Ticket',
          templateName: TEMPLATE.CONTACT_WITH_TICKET
        },
        {
          title: 'Pipeline Stage Report',
          description: 'Pipeline Stage Report',
          templateName: TEMPLATE.PIPELINE_STAGE_REPORT
        },
        {
          title: 'Contact List',
          description: 'Report description will come here',
          templateName: TEMPLATE.CONTACT_LIST
        },
        {
          title: 'Deal List',
          description: 'Report description will come here',
          templateName: TEMPLATE.DEAL_LIST
        },
        // {
        //   title: 'Deal Conversion Report',
        //   description: 'Report description will come here',
        //   templateName: TEMPLATE.DEAL_CONVERSION_REPORT
        // },
        {
          title: 'Activities',
          description: 'Report description will come here',
          templateName: TEMPLATE.ACTIVITY_LIST
        },
        // {
        //   title: 'Campaign Status Report',
        //   description: 'Report description will come here',
        //   templateName: TEMPLATE.CAMPAIGN_STATUS
        // },
        // {
        //   title: 'Unsubscribe Users',
        //   description: 'Report description will come here',
        //   templateName: TEMPLATE.UNSUBSCRIBED_REPORT
        // },
        {
          title: 'Overdue Activities',
          description: 'Report description will come here',
          templateName: TEMPLATE.OVERDUE_ACTIVITY,
          path: PAGE_ROUTES.ACTIVITY_REPORT
        },
        {
          title: 'Activities By Contact',
          description: 'Report description will come here',
          templateName: TEMPLATE.ACTIVITY_BY_CONTACT,
          path: PAGE_ROUTES.ACTIVITY_BY_CONTACT_REPORT
        },
        {
          title: 'Tickets By Contact',
          description: 'Report description will come here',
          templateName: TEMPLATE.TICKET_BY_CONTACT,
          path: PAGE_ROUTES.TICKET_BY_CONTACT_REPORT
        },
        {
          title: 'Automation Report',
          description: 'Report description will come here',
          templateName: TEMPLATE.AUTOMATION_REPORT,
          path: PAGE_ROUTES.AUTOMATION_REPORT
        }
        // {
        //   title: 'Automation Report',
        //   description: 'Report description will come here',
        //   templateName: TEMPLATE.AUTOMATION_REPORT
        // }
      ]
    }
  ];

  static getTemplateData(
    templateGroup: TEMPLATE_GROUP,
    templateName: TEMPLATE
  ) {
    switch (templateGroup) {
      case TEMPLATE_GROUP.ERP_REPORTS:
        return ERPTemplates.getTemplateData(templateName);
      case TEMPLATE_GROUP.ACCOUNTING_REPORTS:
        return AccountingTemplates.getTemplateData(templateName);
      case TEMPLATE_GROUP.CRM_REPORTS:
        return CRMTemplates.getTemplateData(templateName);
      default:
        return getDefaultTemplate();
    }
  }
}

function getDefaultTemplate() {
  return [{
    uid: '',
    data: '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',
    reportDesc:
      'Default template report, containing widget for sales invoices.',
    reportName: 'Default template',
    thumbnail: 'report/thumbnail/25831/1680073732164_blob',
    appName: 'ERP',
    updatable: true,
    systemReport: true,
    favourite: false,
    createdBy: 21524,
    createdDt: '29-Mar-2023',
    updatedDt: '29-Mar-2023'
  }];
}
